import { Options, Vue } from "vue-class-component";
import { UAParser } from "ua-parser-js";

interface OperaWindow extends Window {
  opera?: string;
}

@Options({})
export default class UserAgent extends Vue {
  userAgent: string | undefined =
    navigator.userAgent || navigator.vendor || (window as OperaWindow).opera;

  ua = UAParser(this.userAgent);
  openApp = false;

  params = new URLSearchParams({
    refreshToken: String(localStorage.getItem("refreshToken")),
    access: String(localStorage.getItem("access")),
  });
  baseUrl = `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ""
  }`;
  fullUrl = `${this.baseUrl}?${this.params.toString()}`;

  get uri(): string {
    if (!this.userAgent) return this.fullUrl;

    // Android
    if (/android/i.test(this.userAgent)) {
      return `intent://${this.fullUrl.replace(
        /^https?:\/\//,
        ""
      )}#Intent;package=com.android.chrome;scheme=https;end;`;
    }

    // iOS (iPhone, iPad, iPod)
    if (
      /iPad|iPhone|iPod/i.test(this.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    ) {
      // const chromeUrl = this.fullUrl.replace(/^https?:\/\//, "googlechrome://");
      return `googlechromes://${this.fullUrl.replace(/^https?:\/\//, "")}`;
    }

    // Windows
    if (/Win/i.test(navigator.platform)) {
      return this.fullUrl;
    }

    // macOS
    if (/Mac/i.test(navigator.platform)) {
      return this.fullUrl;
    }

    // Linux
    if (/Linux/i.test(navigator.platform)) {
      return this.fullUrl;
    }

    return this.fullUrl;
  }

  get isWebView(): boolean {
    if (!this.ua.device.is("mobile") || this.openApp) return false;
    if (this.isInAppBrowser) return true;
    if (
      Object.prototype.hasOwnProperty.call(window, "Android") ||
      Object.prototype.hasOwnProperty.call(window, "webkit")
    )
      return true;
    if (window.innerWidth === document.documentElement.clientWidth) return true;
    if (this.forWebos) return true;
    return false;
  }

  get forWebos(): boolean {
    if (!this.userAgent) return false;
    return /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(this.userAgent);
  }

  get isInAppBrowser(): boolean {
    if (!this.userAgent) return false;
    const userAgent = this.userAgent.toLowerCase();

    // Проверка на Android WebView
    if (userAgent.includes("wv") && userAgent.includes("android")) {
      return true;
    }

    // Проверка на Facebook, Instagram, Twitter и другие встроенные браузеры
    const inAppBrowsers = [
      "fbav", // Facebook
      "instagram", // Instagram
      "twitter", // Twitter
      "line", // Line
      "kakao", // KakaoTalk
      "naver", // Naver
      "snapchat", // Snapchat
      "webview", // Общий признак WebView
      "mobile", // Может быть встроенным
      "android", // Android (но не всегда WebView)
      "iphone", // iOS (но не всегда WebView)
    ];

    return inAppBrowsers.some((browser) => userAgent.includes(browser));
  }

  async copy(): Promise<void> {
    try {
      // Проверка поддержки API
      if (!navigator.clipboard) {
        throw new Error("Clipboard API не поддерживается");
      }

      // Проверка URL
      if (typeof this.fullUrl !== "string") {
        throw new Error("URL должен быть строкой");
      }

      await navigator.clipboard.writeText(this.fullUrl);
    } catch (err) {
      console.error("Ошибка копирования:", err);

      // Fallback для старых браузеров
      const textarea = document.createElement("textarea");
      textarea.value = this.fullUrl;
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand("copy");
      } catch (fallbackErr) {
        console.log("Не удалось скопировать ссылку");
      }

      document.body.removeChild(textarea);
    }
  }

  transitionTo(): void {
    this.copy();
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isMobile) {
      // Пытаемся открыть в Chrome
      window.location.href = this.uri;

      // Если Chrome не установлен, через 1 секунду открываем исходный URL
      setTimeout(() => {
        if (!document.hidden) {
          window.location.href = `x-web-search://?${this.fullUrl}`;
        }
      }, 300);
      setTimeout(() => {
        if (!document.hidden) {
          window.open(this.uri, "_blank");
        }
      }, 600);
      // Если Chrome не установлен, через 1 секунду открываем исходный URL
      setTimeout(() => {
        if (!document.hidden) {
          window.location.href = this.fullUrl;
        }
      }, 1000);
    } else window.open(this.uri, "_blank");
  }

  mounted(): void {
    this.$nextTick(() => (this.openApp = !!this.$cookies?.get("openApp")));
    console.log(this.userAgent);

    console.log("UAParser");
    console.log(this.ua.browser.name); // Maemo Browser
    console.log(this.ua.cpu.is("arm")); // true
    console.log(this.ua.device.is("mobile")); // true
    console.log(this.ua.device.model);
  }
}
